<!-- <app-loader [loading]="loading"></app-loader> -->
<div class="wrapper main-body">
    <div class="header">
        <div class="search-bar">
            <button type="submit" class="msicon"><span class="material-symbols-outlined">
                    search</span></button>
            <input aria-label="Number"
                placeholder="Search Project by Client Name, Project Name, Manager Id, Manager Name, Competency, Primary Skill, Secondary Skill..."
                class="form-control" matinput="" type="text" (keyup)="applyFilter($event.target.value,'')"
                [(ngModel)]="searchText">
            <button type="submit" class="msicon bg-color" (click)="applyFilter('','')" *ngIf="searchText"><span
                    class="material-symbols-outlined"> close </span></button>
        </div>
        <div class="main-content" (click)="openPopup()">
            <i class="fas fa-sharp fa-filter filterList ml-2" data-toggle="modal" data-target="#exampleModal"
                title="Filter your search based on specific criteria"></i>
        </div>
        <div class="popup" *ngIf="isVisible">
            <div class="popup-header">
                <div>
                    <label class="advance">Advance Search Filter</label>
                </div>
                <button type="button" class="close m-0 p-0" (click)="closePopup()" data-dismiss="modal"
                    aria-label="Close">
                    <span aria-hidden="true" class="cancel">&times;</span>
                </button>
            </div>
            <div class="popup-body">
                <mat-label class="h5 label-bold w-100" for="dropdown">Search by Filter:</mat-label>
                <mat-select id="dropdown" [(value)]="selectedOption"
                    class="form-control custom-mat-single-select file-type fs-14 black-clr" placeholder="Select">
                    <mat-option *ngFor="let option of options" [value]="option">{{ optionMapping[option] }}</mat-option>
                </mat-select>
                <br>
                <div class="class">
                    <div><span class="secondaryInfo">Enter text: </span></div>
                    <input class="form-control" placeholder="Type text" id="textField" [(ngModel)]="enteredText">
                </div>
                <br>
                <div class="buttons">
                    <button class="btn cancelbtn ml-2" (click)="clearFilter()">
                        Clear
                    </button>
                    <button class="btn applyfilterbtn" data-dismiss="modal" (click)="search()">Search</button>
                </div>
            </div>
        </div>
        <div class="col-2 toggle">
            <mat-slide-toggle class="slide-toggle" color="primary" [(ngModel)]="isProfileCompleted"
                (change)="getdata()">
                <label class="fw-500 pt-3">Project Completed</label>
            </mat-slide-toggle>
        </div>
        <div class="cards d-flex">
            <div class="card card-align">
                <span class="fw-500">Total</span>
                <span>{{profileCompletedCounts?.totalCount}}</span>
            </div>
            <div class="card card-align">
                <span class="fw-500">Completed</span>
                <div class="row">
                    <span class="col-6 items-center">{{profileCompletedCounts?.filledCount}}</span>
                    <div class="col-3 download-popup">
                        <i class="fas fa-download py-3 px-bottom-icons py-3 cursor-pointer"
                            (click)="exportExcel(true,profileCompletedCounts?.filledCount)">
                        </i>
                    </div>

                </div>
            </div>
            <div class="card card-align">
                <span class="fw-500">Not Started</span>
                <div class="row">
                    <span class="col-6 items-center">{{profileCompletedCounts?.notFilledCount}}</span>
                    <div class="col-3 download-popup">
                        <i class="fas fa-download py-3 px-bottom-icons py-3 cursor-pointer"
                            (click)="exportExcel(false,profileCompletedCounts?.notFilledCount)">
                        </i>
                    </div>


                </div>
            </div>
        </div>
    </div>
    <div class="data-grid">
        <mat-table [dataSource]="dataSource" matSort>

            <!-- ID Column -->
            <ng-container matColumnDef="clientName">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Client Name </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.clientName}} </mat-cell>
            </ng-container>

            <!-- Progress Column -->
            <ng-container matColumnDef="projectName">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Project Name </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.projectName}}</mat-cell>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="managerId">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Manager Id </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.managerId}} </mat-cell>
            </ng-container>

            <!-- Color Column -->
            <ng-container matColumnDef="managerName">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Manager Name </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.managerName}} </mat-cell>
            </ng-container>

            <!-- Competency Column -->
            <ng-container *ngIf="isProfileCompleted" matColumnDef="competency">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Competency </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="competency-container" matTooltip="{{getCompetencyNames(row)}}">
                        {{getCompetencyNames(row)}}
                    </div>
                </mat-cell>
            </ng-container>

            <!-- Primary Skills Column -->
            <ng-container *ngIf="isProfileCompleted" matColumnDef="primarySkills">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Primary Skills </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="skills-container" matTooltip="{{getSkills(row, true)}}">
                        {{getSkills(row, true)}}
                    </div>
                </mat-cell>
            </ng-container>

            <!-- Secondary Skills Column -->
            <ng-container *ngIf="isProfileCompleted" matColumnDef="secondarySkills">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Secondary Skills </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="skills-container" matTooltip="{{getSkills(row, false)}}">
                        {{getSkills(row, false)}}
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;">
            </mat-row>
        </mat-table>

        <mat-paginator [length]="totalRecords" [pageSize]="size" [pageSizeOptions]="[5,10,15,20]"
            aria-label="Select page" (page)="getPaginatorData($event)"></mat-paginator>
    </div>
</div>